import { MainThunkDispatch, State } from "../../../Reducers"
import { apiEndpoints } from "../../../Routes/api"
import { AppInboxSettings } from "../../../Models/API/AppSettings"
import { InboxType } from "../../Types"
import {
    apiFetchResponse,
    killPoll,
    pollAPI
} from "../../Client/NetworkActions"
import { failMessage, successMessage } from "../../Client/MessagesActions"

export const getInbox =
    (appID: string) => async (dispatch: MainThunkDispatch) => {
        const response = await dispatch(
            apiFetchResponse(
                `GET_INSTANCE_INBOX_${appID}`,
                apiEndpoints.inbox({ appID })
            )
        )

        if (response === undefined) {
            return
        }

        if (!response.ok) {
            if (response.status === 404) {
                return dispatch({
                    type: InboxType.getInbox,
                    payload: null
                })
            } else {
                return dispatch(failMessage("Failed to load app inbox."))
            }
        }

        const data = (await response.json()) as AppInboxSettings

        if (data === undefined) {
            return
        }

        dispatch({
            type: InboxType.getInbox,
            payload: data
        })
    }

export const createInbox =
    (appID: string) => async (dispatch: MainThunkDispatch) => {
        const response = await dispatch(
            apiFetchResponse(
                `CREATE_INSTANCE_INBOX_${appID}`,
                apiEndpoints.inbox({ appID }),
                {
                    method: "POST"
                }
            )
        )

        if (response === undefined) {
            return
        }

        if (!response.ok) {
            return dispatch(failMessage("Could not create app inbox."))
        }

        dispatch(getInbox(appID))
    }

export const startPollVerifyInbox =
    (appID: string) =>
    async (dispatch: MainThunkDispatch, getState: () => State) => {
        const poll =
            getState().client.network.poll[`POLL_VERIFY_INBOX_${appID}`]
                ?.startTimestamp
        if (!poll) {
            dispatch(
                pollAPI(
                    `POLL_VERIFY_INBOX_${appID}`,
                    apiEndpoints.verifyInbox({ appID }),
                    response => {
                        if (response !== undefined) {
                            dispatch({
                                type: InboxType.verifyInbox,
                                payload: response
                            })
                        }
                    },
                    error => {
                        if (error !== undefined) {
                            return dispatch(
                                failMessage("Failed to verify app inbox.")
                            )
                        }
                    },
                    5000,
                    true
                )
            )
        }
    }

export const stopPollVerifyInbox =
    (appID: string) => async (dispatch: MainThunkDispatch) => {
        dispatch(killPoll(`POLL_VERIFY_INBOX_${appID}`))
    }

export const sendInboxVerification =
    (appID: string) => async (dispatch: MainThunkDispatch) => {
        const response = await dispatch(
            apiFetchResponse(
                `SEND_INBOX_VERIFICATION_${appID}`,
                apiEndpoints.verifyInbox({ appID }),
                {
                    method: "POST"
                }
            )
        )

        if (response === undefined) {
            return
        }

        if (!response.ok) {
            return dispatch(failMessage("Could not send verification request."))
        } else {
            return dispatch(
                successMessage("Successfully sent the verification request.")
            )
        }
    }

export const deleteInbox =
    (appID: string) => async (dispatch: MainThunkDispatch) => {
        const response = await dispatch(
            apiFetchResponse(
                `DELETE_INSTANCE_INBOX_${appID}`,
                apiEndpoints.inbox({ appID }),
                {
                    method: "DELETE"
                }
            )
        )

        if (response === undefined) {
            return
        }

        if (!response.ok) {
            return dispatch(failMessage("Could not delete app inbox."))
        } else {
            dispatch(successMessage("Deleted inbox successfully."))
        }

        dispatch(getInbox(appID))
    }
